import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CommonService {
  constructor(private http: HttpClient) {}

  private getAuthHeaders(extraHeaders?: { [key: string]: string }) {
    const token = localStorage.getItem('authToken');
    let headers = new HttpHeaders({
      'Authorization': token ? `Bearer ${token}` : ''
    });
    if (extraHeaders) {
      Object.entries(extraHeaders).forEach(([k, v]) => headers = headers.set(k, v));
    }
    return headers;
  }

  get<T>(url: string, options: { params?: HttpParams | { [param: string]: string | number | boolean }, headers?: { [key: string]: string } } = {}): Observable<T> {
    return this.http.get<T>(url, {
      params: options.params,
      headers: this.getAuthHeaders(options.headers)
    });
  }

  post<T>(url: string, body: any, options: { params?: HttpParams | { [param: string]: string | number | boolean }, headers?: { [key: string]: string } } = {}): Observable<T> {
    return this.http.post<T>(url, body, {
      params: options.params,
      headers: this.getAuthHeaders(options.headers)
    });
  }

  put<T>(url: string, body: any, options: { params?: HttpParams | { [param: string]: string | number | boolean }, headers?: { [key: string]: string } } = {}): Observable<T> {
    return this.http.put<T>(url, body, {
      params: options.params,
      headers: this.getAuthHeaders(options.headers)
    });
  }

  delete<T>(url: string, options: { params?: HttpParams | { [param: string]: string | number | boolean }, headers?: { [key: string]: string } } = {}): Observable<T> {
    return this.http.delete<T>(url, {
      params: options.params,
      headers: this.getAuthHeaders(options.headers)
    });
  }
  patch<T>(url: string, body: any, options: { params?: HttpParams | { [param: string]: string | number | boolean }, headers?: { [key: string]: string } } = {}): Observable<T> {
    return this.http.patch<T>(url, body, {
      params: options.params,
      headers: this.getAuthHeaders(options.headers)
    });
  }
  upload<T>(url: string, body: any, options: { params?: HttpParams | { [param: string]: string | number | boolean }, headers?: { [key: string]: string } } = {}): Observable<T> {
    return this.http.post<T>(url, body, {
      params: options.params,
      headers: this.getAuthHeaders(options.headers)
    });
  }
  download<T>(url: string, options: { params?: HttpParams | { [param: string]: string | number | boolean }, headers?: { [key: string]: string } } = {}): Observable<T> {
    return this.http.get<T>(url, {
      params: options.params,
      headers: this.getAuthHeaders(options.headers)
    });
  }



}
